import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/file.png'


const _withScopeId = n => (_pushScopeId("data-v-58acaceb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"display":"flex","min-width":"220px"} }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_3 = { style: {"position":"absolute","bottom":"0.5vw","right":"0.5vw"} }

import CheckType from "@/utils/CheckType";
import DownloadUtils from "@/utils/DownloadUtils";
import { ref } from "vue";
type dataList = {
  //数据
  data: string;
  //创建时间
  createTime: string;
  // 接收状态 true为接手 false为发送
  correlationState: boolean;
  //文件路径
  link: string;
  //文件类型 0图片 1视频 2文件
  linkType: number;
  //文件名称
  fileName: string;
  //状态码
  status: number;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'File',
  props: {
    item: null
  },
  setup(__props: any) {

const props = __props as {
  item: dataList;
};

const preview = ref(false);
const _preview = () => {
  preview.value = true;
};

const download = DownloadUtils.DownloadUtils(
  CheckType.isImg(props.item.link),
  props.item.fileName
);
//判断文件是否pdf xlsx docx
const isFile = () =>
  props.item.link.endsWith(".pdf") ||
  props.item.link.endsWith(".xlsx") ||
  props.item.link.endsWith(".docx");
// props.item.fileName.endsWith(".xls");

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", null, [
        _createTextVNode(_toDisplayString(props.item.fileName) + " ", 1),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(download)()))
          }, {
            default: _withCtx(() => [
              _createTextVNode("下载")
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: preview.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((preview).value = $event)),
      title: props.item.fileName,
      width: "80%",
      center: ""
    }, null, 8, ["modelValue", "title"])
  ], 64))
}
}

})